<template>
  <div class="c-ace-editor">
    <div id="c-ace-editor" class="u-ace-editor"></div>
  </div>
</template>

<script type="text/babel">
import { initScripts } from '../../utils/installScript';
import { mapGetters } from 'vuex';
import { emitEvent, onEvent } from '../../utils/eventBus/vueEvent'
import Events from '../../scripts/events/index'
import iframe from '../../scripts/iframe/index'
// import Env from '../../scripts/common/env'

  export default {
    name: 'ace-editor',
    props: {
      aceMode: {
        type: String,
        required: false
      },
      disabled: Boolean
    },
    data() {
      return {
        code: '',
        editor: null,
        modePath: '',
        isRemote: true,
        isDisabled: false,
      }
    },
    computed: {
      ...mapGetters(['ideCode', 'isEdit']),
    },
    mounted() {
      this.loadIde(this.isRemote);
      this.code = this.ideCode
    },
    created() {
      // const ip = Env.signBit.getQueryIp(this.$route.query);
      // if (!(ip & Env.signBit.save || ip & Env.signBit.commit)) {
      if (!this.isEdit) {
        // ro -- readOnly， 1 | true
        this.isDisabled = true
      }

      onEvent(Events.IDE_GET_CODE, type => {
        if (this.editor) {
          emitEvent(Events.YOUTH_SET_CODE, { type, data: this.editor.getValue() });
        }
      })

      onEvent(Events.IDE_SET_CODE, code => {
        this.code = code
        if (this.editor) {
          this.editor.setValue(this.code)
        }
      })

      onEvent(Events.IDE_SET_THEME, theme => {
        if (this.editor) {
          if (theme == 1) {
            this.editor.setOption("theme", 'ace/theme/monokai');
          } else {
            this.editor.setOption("theme", 'ace/theme/chrome');
          }
        }
      })
    },
    methods: {
      loadIde(isRemote) {
        const cloudBaseUrl = isRemote ?
                'https://qceit-static-1258274959.cos.ap-guangzhou.myqcloud.com/editor/ace1-4-12/'
                : `${location.origin}/static/ace1-4-12/`;
        const languages = {
          // js: { src: '../src/mode-javascript.js', mode: 'ace/mode/javascript'},
          py: { src: `${cloudBaseUrl}src/mode-python.js`, mode: 'ace/mode/python'},
          c: { src: `${cloudBaseUrl}src/mode-c_cpp.js`, mode: 'ace/mode/c_cpp'},
        }

        const lang = this.$route.query.lang;
        console.log('com -ace--editor l:', lang);
        const langObj = lang && languages[lang] || languages.c;
        initScripts(
                `${cloudBaseUrl}src/ace.js`,
        ).then(() => {

          initScripts(
                  `${cloudBaseUrl}src/ext-language_tools.js`,
                  `${cloudBaseUrl}src/theme-chrome.js`,
                  // `${cloudBaseUrl}src/theme-monokai.js`,// 黑色主题
                  `${cloudBaseUrl}src/theme-chrome.js`,
                  langObj.src
          ).then(() => {
            this.initAce(langObj);
          }).catch((err) => {
            console.error('initScripts ext-ace err:', err);
            this.initAce(null, 1);
          })
        }).catch((err) => {
          console.error('initScripts ace err:', err);
          this.initAce(null, 2);
        })
      },
      initAce(langObj, errNo) {
        if (errNo || !window.ace) {
          if (this.isRemote) {
            console.error(`initAce err: ${errNo}，isRemote`, this.isRemote)
            this.isRemote = false;
            this.loadIde(this.isRemote);
          } else {
            // emitEvent(Events.OUTPUT_CONSOLE, `编辑器初始化异常: ${errNo}，请尝试其他网络连接方式`)
            // console.error(`编辑器初始化异常: ${errNo}，请尝试其他网络连接方式`, window.ace)
            emitEvent(Events.OUTPUT_CONSOLE, { result: '切换编辑器...' });
            this.$store.dispatch('setIsLocalIde', false);
          }
          return;
        }
        const editor = window.ace.edit('c-ace-editor', {
          fontSize: 14,
          theme: 'ace/theme/chrome',
          mode: langObj.mode,
          tabSize: 2
        })
        editor.setOptions({
          useSoftTabs: true,
          newLineMode: 'auto', // 'auto' | 'unix' | 'windows'
          autoScrollEditorIntoView: true,
          copyWithEmptySelection: true,
          enableBasicAutocompletion: true,
          enableLiveAutocompletion: true,
          enableSnippets: true
        })
        this.editor = editor;
        editor.setHighlightActiveLine(true)
        editor.setHighlightGutterLine(true)
        editor.setShowPrintMargin(false)
        if (this.code) {
          editor.setValue(this.code)
        }
        if (this.disabled || this.isDisabled) {
          editor.setReadOnly(true)
        }
        editor.clearSelection()

        Events.emitIframeEvent({ method: iframe.IDE_READY, data: 'v1.6.8c' })

        editor.on('change', ()=> {
          Events.emitIframeEvent({ method: iframe.IDE_EDIT_CHANGE, data: '' })
        })

        editor.on('blur', ()=> {
          Events.emitIframeEvent({ method: iframe.IDE_EDIT_BLUR, data: '' })
        })
      },
      resize() {
        // this.editor.resize()
      }
    }
  }
</script>

<style lang="scss" scoped>

  @import "../../assets/scss/base/config.scss";

  .c-ace-editor {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;

    > .u-ace-editor {
      display: flex;
      flex-grow: 1;

      .ace_gutter {
        background-color: $c-bg-white;
      }
    }
  }
</style>
